import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Dropdown,
  DropdownButton,
  Spinner,
} from "react-bootstrap";

import TopLimitDropdown from "../../../../../common/TopLimitDropdown";
import AccordionComponent from "../../../../../common/Accordion";
import { useDispatch } from "react-redux";
import {
  setIsDashboard,
  setNewCaseInFoID,
} from "../../../../../redux/slice/CaseHeaderSlice";
import { formatDate } from "react-datepicker/dist/date_utils";
import { formattedDate } from "../../../../../utils/dateUtils";
import { getTranscriberRushNotesSummary } from "../../../../../services/TranscriberDashboardAPI";

interface TranscriberRushNotesProps {
  openDropdown: string | null;
  setOpenDropdown: React.Dispatch<React.SetStateAction<string | null>>;
}

const TranscriberRushNotes: React.FC<TranscriberRushNotesProps> = ({
  openDropdown,
  setOpenDropdown,
}) => {
  const dispatch = useDispatch();
  const [limit, setLimit] = useState<number>(5);
  const [limitLabel, setLimitLabel] = useState<string>("Top 5");
  const [rushNotesData, setRushNotesData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [visibleHeaderIndex, setVisibleHeaderIndex] = useState<boolean>(false);

  const fetchRushNotes = async (limitValue: number) => {
    setLoading(true);
    try {
      const data = await getTranscriberRushNotesSummary(limitValue);
      setRushNotesData(data);
    } catch (error) {
      console.error("Failed to fetch latest cases:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRushNotes(limit);
  }, [limit]);

  const handleLimitChange = (value: number, label: string) => {
    setLimit(value);
    setLimitLabel(label);
  };

  const [LatestCaseKey, setLatestCaseKey] = useState<string | null>("0");

  const handleBodyAccordionSelect = (key: string | null) => {
    // Prevent collapsing if the same key is clicked
    if (LatestCaseKey === key) {
      return; // do nothing
    }
    setLatestCaseKey(key || "0");
  };

  const LatestCaseAccordion = (
    items: { title: JSX.Element; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={LatestCaseKey}
      onSelect={handleBodyAccordionSelect}
      isDashboard={true}
    />
  );

  return (
    <>
      {LatestCaseAccordion([
        {
          title: (
            <div className="d-flex align-items-center w-100">
              {/* Left Title Section */}
              <div className="me-auto d-flex flex-column">
                <span className="fw-semibold">Rush Notes</span>
                <span
                  style={{
                    fontSize: "12px",
                    fontStyle: "italic",
                    color: "#6c757d",
                  }}
                >
                  Case Requiring Immediate Action
                </span>
              </div>

              {/* Dropdown */}
              <div onClick={(e) => e.stopPropagation()}>
                <TopLimitDropdown
                  title={limitLabel}
                  onSelect={handleLimitChange}
                  show={openDropdown === "TranscriberRush"}
                  onToggle={(isOpen) =>
                    setOpenDropdown(isOpen ? "TranscriberRush" : null)
                  }
                />
              </div>
            </div>
          ),
          content: (
            <>
              <Card className="border-0 ">
                <Card.Body className="d-flex flex-column p-0 bg-theme">
                  <div
                    style={{
                      maxHeight: limit > 5 ? "250px" : "auto",
                      overflowY: "auto",
                    }}
                    className="d-flex flex-column gap-1 flex-grow-1"
                  >
                    {rushNotesData.length === 0 ? (
                      <p>No cases found.</p>
                    ) : (
                      rushNotesData.map((item, index) => (
                        <div
                          key={index}
                          className="p-2 mb-1 slide-up-onload"
                          style={{
                            background: "#ffffff",
                            borderRadius: "6px",
                            border: "1px solid #e6edf5",
                          }}
                        >
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              columnGap: "12px",
                              rowGap: "0px",
                              fontSize: "13px",
                              lineHeight: "1.1",
                            }}
                          >
                            {/* Patient Name */}
                            <div className="text-truncate fw-medium m-0 p-0">
                              {item.patientName || "-"}
                            </div>

                            {/* Date */}
                            <div
                              className="text-end m-0 p-0"
                              style={{
                                borderLeft: "1px solid #e6edf5",
                                paddingLeft: "12px",
                              }}
                            >
                              {formattedDate(item.lastModifiedDate)}
                            </div>

                            {/* Case ID */}
                            <a
                              href="#/search-case"
                              className="text-primary text-decoration-underline text-truncate m-0 p-0"
                              style={{ fontSize: "12.5px" }}
                              onClick={() => {
                                dispatch(setIsDashboard(true));
                                dispatch(setNewCaseInFoID(item.caseInfoId));
                                setVisibleHeaderIndex(true);
                              }}
                            >
                              {item.claimNumber || "-"}
                            </a>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </Card.Body>
              </Card>
            </>
          ),
        },
      ])}
    </>
  );
};

export default TranscriberRushNotes;
